import { render, staticRenderFns } from "./FlashOffers.vue?vue&type=template&id=fbbc6834&"
import script from "./FlashOffers.vue?vue&type=script&lang=ts&"
export * from "./FlashOffers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports